import { createUrl, restGet } from '~/src/dash/api/rest';
import { ISelectOption } from '~/src/dash/components/dropdowns/common';

export async function fetchSmallBidderGroupsOptionsList(
  publisherID: string,
): Promise<ISelectOption[]> {
  const reqUrl = createUrl('/ui_options/bidder_groups', publisherID, 'v1');
  try {
    const response = await restGet<ISelectOption[]>(reqUrl, {});
    return response.parsedBody as ISelectOption[];
  } catch (err) {
    throw err;
  }
}

export async function fetchSmallBiddersOptionsList(publisherID: string): Promise<ISelectOption[]> {
  const reqUrl = createUrl('/ui_options/small_bidders', publisherID, 'v1');
  try {
    const response = await restGet<ISelectOption[]>(reqUrl, {});
    return response.parsedBody as ISelectOption[];
  } catch (err) {
    throw err;
  }
}

export async function fetchSmallChannelsOptionsList(publisherID: string): Promise<ISelectOption[]> {
  const reqUrl = createUrl('/ui_options/small_sites', publisherID, 'v1');
  try {
    const response = await restGet<ISelectOption[]>(reqUrl, {});
    return response.parsedBody as ISelectOption[];
  } catch (err) {
    throw err;
  }
}

export async function getCreativeValidationUsersByPublisherOptionsList(
  publisherID: string,
  reviewStatus: number,
): Promise<ISelectOption[]> {
  const reqUrl = createUrl(
    `/ui_options/creative_validation_users/${reviewStatus}`,
    publisherID,
    'v1',
  );
  try {
    const response = await restGet<ISelectOption[]>(reqUrl, {});
    return response.parsedBody as ISelectOption[];
  } catch (err) {
    throw err;
  }
}

export async function getCreativeValidationAdomainsByPublisherOptionsList(
  publisherID: string,
  reviewStatus: number,
): Promise<ISelectOption[]> {
  const reqUrl = createUrl(
    `/ui_options/creative_validation_adomains/${reviewStatus}`,
    publisherID,
    'v1',
  );
  try {
    const response = await restGet<ISelectOption[]>(reqUrl, {});
    return response.parsedBody as ISelectOption[];
  } catch (err) {
    throw err;
  }
}
